/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vcG1zL2N1c3RvbWVyL3RyYW5zYWN0aW9ucy9zZWFyY2gtdHJhbnNhY3Rpb24vc2VhcmNoLXRyYW5zYWN0aW9uLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
